import { Flex, Stack, useColorMode } from "@chakra-ui/react";
import React from "react";

const ChooseAccountCard = ({ children, ...props }) => {
  const { colorMode } = useColorMode();
  return (
    <Flex
      mt={{ base: 5, "2xl": 12 }}
      mb={{ base: 10, "2xl": 8 }}
      w={"full"}
      boxShadow={"md"}
      maxW={{ base: "full", sm: "550px", md: "680px", "2xl": "530px" }}
      minH={"640px"}
      borderRadius={24}
      direction={"column"}
      py={{ base: "34px", "2xl": "34px" }}
      px={{ base: "24px", "2xl": "34px" }}
      bg={colorMode === "light" ? "white" : "rgba(0, 178, 149, 0.33)"}
      color={"black"}
      justify={"center"}
      align={"flex-start"}
      {...props}
    >
      <Stack
        direction={{ base: "column" }}
        w={"full"}
        justify={"space-between"}
        alignItems={"center"}
      >
        {children}
      </Stack>
    </Flex>
  );
};

export default ChooseAccountCard;
